export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6297.9d4817f6.jpg";